module.exports = __webpack_public_path__ + "static/media/covid-19.486d0875.svg";